export interface Balance {
    /**
     * A valid UUID
     * @type {string}
     * @memberof Balance
     */
    id: string;
    /**
     * A valid id that supports uuid and nanoid
     * @type {string}
     * @memberof Balance
     */
    user_id: string;
    /**
     * A valid id that supports uuid and nanoid
     * @type {string}
     * @memberof Balance
     */
    profile_id: string;
    /**
     * A valid currency
     * @type {string}
     * @memberof Balance
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof Balance
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Balance
     */
    type: BalanceTypeEnum;
    /**
     * 
     * @type {AmountWithCurrencyAndFiat}
     * @memberof Balance
     */
    pending: AmountWithCurrencyAndFiat;
    /**
     * 
     * @type {AmountWithCurrencyAndFiat}
     * @memberof Balance
     */
    available: AmountWithCurrencyAndFiat;
    /**
     * 
     * @type {AmountWithCurrencyAndFiat}
     * @memberof Balance
     */
    savings: AmountWithCurrencyAndFiat;
    /**
     * 
     * @type {AmountWithCurrencyAndFiat}
     * @memberof Balance
     */
    investments: AmountWithCurrencyAndFiat;
    /**
     * 
     * @type {AmountWithCurrencyAndFiat}
     * @memberof Balance
     */
    total: AmountWithCurrencyAndFiat;
    /**
     * This field is used to determine whether to show zero balances in the response or not
     * @type {boolean}
     * @memberof Balance
     */
    show_zero?: boolean;
    /**
     * This field is used to determine if the currency can be traded
     * @type {boolean}
     * @memberof Balance
     */
    trade?: boolean;
    /**
     * This field is used to determine if the currency can be deposited
     * @type {boolean}
     * @memberof Balance
     */
    deposit?: boolean;
    /**
     * This field is used to determine if the currency can be withdrawn
     * @type {boolean}
     * @memberof Balance
     */
    withdrawal?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum BalanceTypeEnum {
    fiat = 'fiat',
    crypto = 'crypto'
}

export interface AmountWithCurrencyAndFiat {
    /**
     * decimal value
     * @type {string}
     * @memberof AmountWithCurrencyAndFiat
     */
    amount: string;
    /**
     * A valid currency
     * @type {string}
     * @memberof AmountWithCurrencyAndFiat
     */
    currency: string;
    /**
     * amount in fiat
     * @type {AmountWithCurrency}
     * @memberof AmountWithCurrencyAndFiat
     */
    fiat?: AmountWithCurrency;
}

export interface AmountWithCurrency {
    /**
     * decimal value
     * @type {string}
     * @memberof AmountWithCurrency
     */
    amount: string;
    /**
     * A valid currency
     * @type {string}
     * @memberof AmountWithCurrency
     */
    currency: string;
}
